import { DatePipe } from "@angular/common";
import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import { take } from "rxjs";

// Raj: Reference for custom validator methods: https://stackoverflow.com/a/72650714/260665
export class UDXValidators {
  static numbersOnly(control: AbstractControl): ValidationErrors | null {
    var errorObject: ValidationErrors | null = null;
    let userInput = control.value;
    // console.log ("userInput: " + userInput);
    if (userInput) {
      let isDigitsOnly = /^[0-9]*$/.test(userInput);
      if (!isDigitsOnly) {
        errorObject = { notDigits: true };
      }
      // console.log ("isDigitsOnly:" + isDigitsOnly);
    }
    return errorObject;
  }

  static alphaNumeric(control: AbstractControl): ValidationErrors | null {
    // https://stackoverflow.com/a/63566133/260665
    const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9_]*$/;
    var errorObject: ValidationErrors | null = null;
    let userInput = control.value;
    // console.log ("userInput: " + userInput);
    if (userInput) {
      let isDigitsOnly = ALPHA_NUMERIC_REGEX.test(userInput);
      if (!isDigitsOnly) {
        errorObject = { notAlphanumeric: true };
      }
      // console.log ("isDigitsOnly:" + isDigitsOnly);
    }
    return errorObject;
  }

  static alphaNumericOrEmail(control: AbstractControl): ValidationErrors | null {
    // USJCOMM-8382
    // Regex for alphanumeric validation
    const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9_]*$/;
    // Regex for email validation
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    let userInput = control.value;
    let errorObject: ValidationErrors | null = null;
  
    if (userInput) {
      // Check if input matches either alphanumeric or email format
      const isAlphaNumeric = ALPHA_NUMERIC_REGEX.test(userInput);
      const isEmail = EMAIL_REGEX.test(userInput);
  
      if (!isAlphaNumeric && !isEmail) {
        errorObject = { notAlphaNumericOrEmail: true };
      }
    }
  
    return errorObject;
  }

  static emailConfirm(confirmEmailInput: string) {
    // From: https://stackoverflow.com/a/52527848/260665
    let confirmEmailControl: FormControl;
    let emailControl: FormControl;

    return (control: FormControl) => {
      if (!control.parent) {
        return null;
      }

      if (!confirmEmailControl) {
        confirmEmailControl = control;
        emailControl = control.parent.get(confirmEmailInput) as FormControl;
        emailControl.valueChanges.pipe(take(1)).subscribe(() => {
          confirmEmailControl.updateValueAndValidity();
        });
      }

      if (emailControl.value && confirmEmailControl.value) {
        if (emailControl.value.toLocaleLowerCase() !== confirmEmailControl.value.toLocaleLowerCase()) {
          return { notMatch: true };
        }
      }

      return null;
    };
  }
  convertGroupRulesDateFormat(inputDate: string | undefined): string {
    if (!inputDate) {
      return ''; 
    }
    const parts = inputDate.split('/');
    const formattedDate = `${parts[2]}/${parts[0]}/${parts[1]}`;
    return formattedDate;
  }
  convertDateTimeFormat(inputDate: string | undefined): string {
    if (!inputDate) {
      return ''; 
    }
    const [datePart, timePart] = inputDate.split(' ');

  // Format the date part
  const dateParts = datePart.split('/');
  const formattedDate = `${dateParts[2]}/${dateParts[0]}/${dateParts[1]}`;

  // Combine the formatted date and the time part
  const formattedDateTime = `${formattedDate} ${timePart}`;
  return formattedDateTime;
  }

  static convertDateTimeToStdFormat(inputDate: Date | undefined): string | null {
    var transformedDateStr: string | null;
    let formatPipe = new DatePipe('en-US');
    transformedDateStr = formatPipe.transform(inputDate, 'yyyy-MM-dd HH:mm:ss');
    return transformedDateStr;
  }
  convertDateOnly(inputDate: string | undefined): string {
    if (inputDate){
      const dateParts = inputDate.split(" ");
      const formattedDate = dateParts[0];
      return formattedDate;
    }
    return '';
  }
}